import { useTranslation } from 'react-i18next'
import Folder from '../svg/Folder'

const EmptyFolders = (): JSX.Element => {
  const { t } = useTranslation()

  return (
    <div className="empty-state-container">
      <div className="empty-icon-wrapper">
        <Folder color='currentColor' />
      </div>
      <h3 className="empty-title">{t('common.no-folder-found')}</h3>
      <p className="empty-subtitle">{t('common.no-folder-found-subtitle')}</p>
    </div>
  )
}

export default EmptyFolders
